import useSWR from 'swr';
import { transactionsDpRecommendation } from 'integration/generated/transactions';
import { useSettings } from '@/data/Settings';
import { useNextRouter } from '@/data/Content/_NextRouter';
import { getClientSideCommon } from '@/data/utils/getClientSideCommon';
import { useExtraRequestParameters } from '@/data/Content/_ExtraRequestParameters';

export const iaRecommendation =
	(pub = true) =>
	async (
		storeId: string,
		partnumber: string,
		query: any,
		params: any,
		filters: Array<any> = []
	) => {
		try {
			return await transactionsDpRecommendation(pub).iaRecommendation(
				storeId,
				{
					type: ['outfit', 'recommendations'],
					rules: {
						params: {
							partnumber,
							limit: 20,
						},
						filters: {
							values: filters,
						},
						priority: {
							values: [],
						},
					},
				},
				query,
				params
			);
		} catch {
			return undefined;
		}
	};

const DATA_KEY_DP_IA_RECOMMENDATION = 'dpIaRecommendation';

export const useGetDpIARecommendation = (partNumber?: string, filters: Array<any> = []) => {
	const { settings } = useSettings();
	const router = useNextRouter();
	const { storeId } = getClientSideCommon(settings, router);
	const params = useExtraRequestParameters();

	const baseQuery = useSWR(
		storeId && partNumber
			? [{ storeId, partNumber, filters }, DATA_KEY_DP_IA_RECOMMENDATION]
			: null,
		async ([{ storeId, partNumber, filters }]) =>
			await iaRecommendation(true)(storeId, partNumber, {}, params, filters)
	);

	return baseQuery;
};
